import { render, staticRenderFns } from "./CoverLetterTemplates.vue?vue&type=template&id=cde57048&scoped=true&"
import script from "./CoverLetterTemplates.vue?vue&type=script&lang=ts&"
export * from "./CoverLetterTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde57048",
  null
  
)

export default component.exports